import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export interface DateFieldProps {
  timestamp?: number;
  format: string;
  isoString?: string;
}

export const AllieDateField = ({ timestamp, format, isoString }: DateFieldProps) => {
  const formatedDate = timestamp
    ? dayjs.unix(timestamp).format(format)
    : dayjs(isoString).format(format);

  return <span>{formatedDate}</span>;
};
